import { render, staticRenderFns } from "./CardOptions.vue?vue&type=template&id=5b147fec&scoped=true"
import script from "./CardOptions.vue?vue&type=script&lang=js"
export * from "./CardOptions.vue?vue&type=script&lang=js"
import style0 from "./CardOptions.vue?vue&type=style&index=0&id=5b147fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b147fec",
  null
  
)

export default component.exports